import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      onlineSupport: {
        supportChat: {
          component: defineMessages({
            customerSupport: {
              id: 'pages.landing.onlineSupport.supportChat.component.customerSupport',
              defaultMessage: 'Customer Support',
            },
            sendButton: {
              id: 'pages.landing.onlineSupport.supportChat.component.sendButton',
              defaultMessage: 'Send',
            },
            connectionFailed: {
              id: 'pages.landing.onlineSupport.supportChat.component.connectionFailed',
              defaultMessage: 'Support chat connection failed. Please try again later!',
            },
            duplicateConnection: {
              id: 'pages.landing.onlineSupport.supportChat.component.duplicateConnection',
              defaultMessage: 'It seems that you are already connected to support chat. Connection closed.',
            },
            placeholder: {
              id: 'pages.landing.onlineSupport.supportChat.component.placeholder',
              defaultMessage: 'Type your message...',
            },
            typing: {
              id: 'pages.landing.onlineSupport.supportChat.component.typing',
              defaultMessage: 'Support is typing...',
            },
            userKicked: {
              id: 'pages.landing.onlineSupport.supportChat.component.userKicked',
              defaultMessage: 'Disconnected by admin',
            },
            userNick: {
              id: 'pages.landing.onlineSupport.supportChat.component.userNick',
              defaultMessage: 'You',
            },
            welcome: {
              id: 'pages.landing.onlineSupport.supportChat.component.welcome',
              defaultMessage: 'Welcome to the Online Help Center!',
            },
            initializing: {
              id: 'pages.landing.onlineSupport.supportChat.component.initializing',
              defaultMessage: 'Initializing... please wait',
            },
            headerWithTranslations: {
              id: 'pages.landing.onlineSupport.supportChat.component.headerWithTranslations',
              defaultMessage: 'Messages are automatically translated, you can chat in English',
            },
          }),
          errors: defineMessages({
            unexpected: {
              id: 'pages.landing.onlineSupport.supportChat.errors.unexpected',
              defaultMessage: 'An error occurred. Please, reload the page or try again later.',
            },
          }),
        },
      },
    },
  },
};
